import {
    type GetAccountsQueryVariables,
    type MutationAccountAddArgs,
    type MutationAccountRemoveArgs,
    type MutationAccountVerifyArgs,
    type Query,
} from '@pkg/graphql/codegen/graphql';
import accountAddMutation from '@pkg/graphql/mutations/accountAdd.graphql';
import accountRemoveMutation from '@pkg/graphql/mutations/accountRemove.graphql';
import accountVerifyMutation from '@pkg/graphql/mutations/accountVerify.graphql';
import { accounts } from '@pkg/graphql/queries';

import { type BaseParams, graphqlReturnResults, Request, type Settings } from '@app/client';

type RequestProps<T> = BaseParams & { variables: T };
type WalletByProps = RequestProps<GetAccountsQueryVariables>;
type WalletAddProps = {
    settings?: Settings;
    variables: MutationAccountAddArgs;
};
type VerifyWalletProps = RequestProps<MutationAccountVerifyArgs>;

type WalletRemoveProps = {
    settings?: Settings;
    variables: MutationAccountRemoveArgs;
};

async function addWallet(params: WalletAddProps) {
    return Request.graphqlMutation({
        ...params,
        query: accountAddMutation,
        apiSettingsType: 'marketplace',
    });
}

async function removeWallet(params: WalletRemoveProps) {
    return Request.graphqlMutation({
        ...params,
        query: accountRemoveMutation,
        apiSettingsType: 'marketplace',
    });
}

async function verifyWallet(params: VerifyWalletProps) {
    return Request.graphqlMutation({
        ...params,
        query: accountVerifyMutation,
        apiSettingsType: 'marketplace',
    });
}

async function getAccounts(params: WalletByProps) {
    return Request.graphqlQuery({
        ...params,
        query: accounts,
        apiSettingsType: 'marketplace',
    });
}

export const callGetAccounts = (params: WalletByProps): Promise<Query> => graphqlReturnResults(getAccounts, params);
export const callVerifyWallet = (params: VerifyWalletProps) => graphqlReturnResults(verifyWallet, params);
export const callAddWallet = (params: WalletAddProps) => graphqlReturnResults(addWallet, params);
export const callRemoveWallet = (params: WalletRemoveProps) => graphqlReturnResults(removeWallet, params);
